<template>
  <div
    style="color: black; z-index: 1;  top: 0; left: 0; right: 0; bottom: 0; min-height: 200px;"
    :style="{
      position: inline == true ? 'initial' : 'absolute',
      'background-color': backgroundColor
    }"
    class="pa-2"
  >
    <v-layout fill-height column justify-center>
      <div class="text-xs-center mt-4" :style="{ 'margin-top': marginTop + 'px' }">
        <img src="/static/img/assets/icon/z-12.png" alt style="width: 100%; max-width: 100px" />
        <h1 style="text-shadow: 1px 1px 20px #9e9e9e;" class="mb-2">
          {{ $t('Its time to upgrade.') }}
        </h1>

        <template v-if="selectedBot.pagetype != 'enterprise'">
          <p style="text-shadow: rgb(80, 80, 80) 1px 1px 20px;">
            <template v-if="type == 'premium'">
              {{
                text === ''
                  ? $t('Upgrade Your Plan to use {package} features , only {price} THB/month', {
                      price: packages.premium.price,
                      package: $t('PREMIUM')
                    })
                  : $t(text)
              }}
            </template>
            <template v-else-if="type == 'advanced'">
              {{
                text === ''
                  ? $t('Upgrade Your Plan to use {package} features , only {price} THB/month', {
                      price: packages.premium.price,
                      package: $t('PREMIUM')
                    })
                  : $t(text)
              }}
            </template>
          </p>

          <v-btn
            depressed
            style="margin-bottom:1.5em"
            :to="'/' + $i18n.locale() + '/upgrade'"
            small
            color="primary"
          >
            <template v-if="type == 'premium'">
              {{ $t('Upgrade to {package} Plan', { package: $t('PREMIUM') }) }}
            </template>
            <template v-else-if="type == 'advanced'">
              {{ $t('Upgrade to {package} Plan', { package: $t('ADVANCED') }) }}
            </template>
          </v-btn>
        </template>
      </div>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    showAll: {
      default: true
    },
    inline: {
      default: false
    },
    marginTop: {
      default: 0
    },
    backgroundColor: {
      default: '#ecececbd'
    },
    size: {
      default: 'small'
    },
    type: {
      default: 'premium'
    },
    text: {
      default: ''
    }
  },
  data() {
    return {
      packages: this.getPackageDetail()
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/elements/PremiumPlanPopup2.vue